import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { SharedOffersService } from 'src/app/shared/offers-shared/offers.service';
import * as actions from 'src/app/recruiting/candidates/live-nurses-new/store/live-nurses.actions';

@Injectable()
export class SubmittalVerballyAcceptEffect {
    setSubmittalAsVerballyAccepted$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(actions.setSubmittalAsVerballyAccepted),
            switchMap((action) => {
                return this._offersService.putToVerballyAcceptedStatus(action.offerId, action.isRecruiting).pipe(
                    map(() =>
                        actions.setSubmittalAsVerballyAcceptedSuccess({
                            offerId: action.offerId
                        })
                    ),
                    catchError(() => of(actions.setSubmittalAsVerballyAcceptedFailure()))
                );
            })
        );
    });

    verbalAcceptanceSuccess$ = createEffect(
        () => {
            return this._actions$.pipe(
                ofType(actions.setSubmittalAsVerballyAcceptedSuccess),
                tap(() => {
                    this._toaster.toast('The verbal acceptance of the offer has been shared');
                })
            );
        },
        { dispatch: false }
    );

    verbalAcceptanceFailure$ = createEffect(
        () => {
            return this._actions$.pipe(
                ofType(actions.setSubmittalAsVerballyAcceptedFailure),
                tap(() => {
                    this._toaster.toast('Error occurred trying to set offer as verbally accepted', 7000);
                })
            );
        },
        { dispatch: false }
    );

    constructor(
        private readonly _actions$: Actions,
        private readonly _offersService: SharedOffersService,
        private readonly _toaster: ToasterService
    ) {}
}
